import React, { Component } from 'react';
import { Gateway } from '../BaseUrl';
import { Input } from './Input';
import { Form } from './Form';
import { Button } from './Button';

export default class ChangePassword extends Component {
    displayName = ChangePassword.name

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            sent: false,
            hasError: false,
            errorMessage: "An error seems to have occured. Try submitting your new password again.",
            currentPassword: "",
            confirmPassword: "",
            newPassword: ""
        }
        
        this.props.changeLogo("default");

        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        this.current = React.createRef();
        this.new = React.createRef();
        this.confirm = React.createRef();
        this.changePassword = this.changePassword.bind(this);
    }

    changePassword() {
        this.setState({
            loading: true
        });     
        var err = false;
        fetch(Gateway + '/User/PasswordReset', {
            method: "POST",
            headers: {
                "Authorization": "Bearer " + this.props.token,
                "Content-Type": "application/json" 
            },
            body: JSON.stringify({
                OldPassword: this.state.currentPassword,
                NewPassword: this.state.newPassword 
            })
        }).then(response => {
            if (response.ok) {
                return response.text();
            } else {
                if (response.status == 401) {
                    this.props.Logout(true)
                }
                if (response.status == 503 || response.status == 403) {
                    throw Error(response.statusText);
                } else {
                    err = true;
                    return response.json();
                }
            }
            }).then(data => {
                if (err) {
                    this.setState({
                        errorMessage: data.message,
                        sent: true,
                        hasError: true,
                        loading: false
                    });
                } else {
                    this.setState({
                        loading: false,
                        sent: true,
                        hasError: false,
                        currentPassword: "",
                        confirmPassword: "",
                        newPassword: ""
                    });
                }
        }).catch((e) => {
            console.log("error", e);
            this.setState({
                loading: false,
                sent: true,
                hasError: true
            });         
        });
    };

    render() {
        return (
            <div style={{ width: "100%" }}>
            <div className="page-container" >
                    <Form onSubmit={() => this.changePassword()}>
                        {this.state.sent ?
                            this.state.hasError ?
                                <div>
                                    <h2>Oops.. Something went wrong!</h2>
                                    <div className="error" style={{ border: "1px solid", marginBottom: "15px", padding: "5px 10px", borderRadius: "3px" }}>
                                        <i className="fas fa-exclamation-triangle" /> {this.state.errorMessage}
                                    </div>
                                </div> :
                                <div>
                                    <h2>Thank you!</h2>
                                    <p>Your password has been sucessfully updated.</p>
                                </div>
                            :
                            <div>
                                <h2>Change Your Password</h2>
                                <p>Enter your old password and new password in the form below.</p>
                            </div>
                        }
                        <Input required={true}
                            rules={[
                                'minLength',
                                'AplhaNumberic',
                                'containNumber',
                                'containUpperCase',
                                'repeatingChars'
                            ]}
                            placeholder="Current password"
                            ref={this.current}
                            type="password"
                            value={this.state.currentPassword}
                            onChange={(e) => this.setState({ currentPassword: e.target.value.trim() })} />

                        <Input required={true}
                            rules={[
                                'minLength',
                                'AplhaNumberic',
                                'containNumber',
                                'containUpperCase',
                                'repeatingChars'
                            ]}
                            placeholder="New Password"
                            ref={this.new}
                            type="password"
                            value={this.state.newPassword}
                            onChange={(e) => this.setState({ newPassword: e.target.value.trim() })} />

                        <Input placeholder="Confirm new password"
                            type="password"
                            ref={this.confirm}
                            required={true}
                            matchString={true}
                            matchMessage="Password's don't match"
                            stringToMatch={this.state.newPassword}
                            isValid={(e) => this.setState({ isConfirmValid: e })}
                            value={this.state.confirmPassword}
                            onChange={(e) => this.setState({ confirmPassword: e.target.value.trim() })}
                        />
                        <div className="form-group">
                            <Button value="Save" loading={this.state.loading} type="submit" />
                        </div>
                    </Form>
                </div>
            </div>	
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ChangePassword.js